import * as React from 'react';
import {IconButton, Dialog, FontIcon} from 'material-ui';
import * as _ from 'lodash';
import {colors as Colors} from 'material-ui/styles';
import {DialogProps} from 'material-ui';

export const TITLE_THEME_DARK = 'dark';
export const TITLE_THEME_WHITE = 'white';
const styles = {
    title: {
        [TITLE_THEME_DARK]: {
            padding: '0px 0px 0px 20px',
            backgroundColor: Colors.grey800,
            color: Colors.white,
            height: 45,
            fontSize: 24,
        } as React.CSSProperties
    } as any,
    close: {
        [TITLE_THEME_WHITE]: {
            position: 'absolute',
            right: 15,
            top: 15,
        } as React.CSSProperties
    } as any
};

interface BaseDialogProps extends DialogProps {
    onClose?: (...args: any[]) => any;
    open: boolean;
    titleTheme: string;
    title: string;
    closeButtonColor: string;
    titleStyle: React.CSSProperties;
}
export default class BaseDialog extends React.Component<BaseDialogProps, {}> {

    static defaultProps = {
        titleTheme: TITLE_THEME_WHITE,
    } as Partial<BaseDialogProps>;

    componentDidUpdate(prevProps: Readonly<BaseDialogProps>) {
        const {onClose} = this.props;
        if (prevProps.open && !this.props.open) {
            if (_.isFunction(onClose)) {
                onClose();
            }
        }
    }

    render() {
        const {titleTheme, title, titleStyle, children, closeButtonColor, ...props} = this.props;
        const {onRequestClose} = this.props;
        return (
            <Dialog
                titleStyle={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    ...styles.title[titleTheme],
                    ...titleStyle
                }}
                title={<div>
                    {title}
                    {_.isFunction(onRequestClose) &&
                    <IconButton
                        onClick={onRequestClose}
                        style={styles.close[titleTheme]}
                    >
                        <FontIcon color={closeButtonColor} className="material-icons">close</FontIcon>
                    </IconButton>}
                </div>} {...props}
            >
                {children}
            </Dialog>);
    }
}
